var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[_c(_vm.pageComponent,{key:_vm.locale,tag:"component",on:{"switch-language":_vm.switchLanguage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }